export enum LoadingScreenType {
    Open,
    Close
}
